(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jem-fluid-offer"] && !Shopify.designMode) return;
  try {
    if(!window.__jemFluidOfferBoundV2){
  window.__jemFluidOfferBoundV2=true;
  const formatMoney=(root,cents)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(cents/100);
  const sync=(root,requested)=>{
    const form=root.closest('form');
    const native=form&&form.querySelector('.quantity-selector__value[name="quantity"],input[type="hidden"][name="quantity"]');
    const visible=root.querySelector('[data-jem-quantity]');
    const min=Math.max(1,Number(native?.min||visible.min||1));
    const step=Math.max(1,Number(native?.step||visible.step||1));
    const max=Number(native?.max||visible.max||0);
    let quantity=Math.max(min,Number.isFinite(Number(requested))?Number(requested):min);
    quantity=min+Math.round((quantity-min)/step)*step;
    if(max>0)quantity=Math.min(quantity,max);
    visible.value=String(quantity);
    if(native&&native.value!==String(quantity)){
      native.value=String(quantity);
      native.dispatchEvent(new Event('input',{bubbles:true}));
      native.dispatchEvent(new Event('change',{bubbles:true}));
    }
    root.querySelectorAll('[data-jem-set]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.jemSet)===quantity)));
    root.querySelector('[data-jem-total]').textContent=formatMoney(root,Math.round(Number(root.dataset.unitCents||0)*quantity));
    root.querySelector('[data-jem-status]').textContent=quantity>=3?'Free shipping appears at checkout when eligible.':`Add ${3-quantity} more ${3-quantity===1?'case':'cases'} of this same fluid for eligible U.S. free shipping.`;
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-jem-set],[data-jem-adjust]');
    if(!button||button.disabled)return;
    const root=button.closest('[data-jem-fluid-offer]');
    if(!root)return;
    const current=Number(root.querySelector('[data-jem-quantity]').value||1);
    sync(root,button.hasAttribute('data-jem-set')?Number(button.dataset.jemSet):current+Number(button.dataset.jemAdjust));
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-jem-quantity]'))sync(event.target.closest('[data-jem-fluid-offer]'),event.target.value);
  });
}
  } catch(e) { console.error(e); }
})();

})();
